import React from 'react';
import './Gallery.css';

const Gallery = () => {
  // Original images from the cloud
  const cdnImages = [
    { url: 'https://customer-assets.emergentagent.com/job_80ab25e3-c50b-48e9-b61c-5ff9eb1da9ab/artifacts/n4qhcp63_Screenshot%202025-12-28%20at%209.47.16%E2%80%AFPM.png', alt: 'Delicious Dosa with Chutneys' },
    { url: 'https://customer-assets.emergentagent.com/job_80ab25e3-c50b-48e9-b61c-5ff9eb1da9ab/artifacts/p9duyywa_Screenshot%202025-12-28%20at%209.54.43%E2%80%AFPM.png', alt: 'Mutton Biryani' },
    { url: 'https://customer-assets.emergentagent.com/job_80ab25e3-c50b-48e9-b61c-5ff9eb1da9ab/artifacts/pw8ht3yq_Screenshot%202025-12-28%20at%2010.00.55%E2%80%AFPM.png', alt: 'Idiyappam String Hoppers' },
    { url: 'https://customer-assets.emergentagent.com/job_80ab25e3-c50b-48e9-b61c-5ff9eb1da9ab/artifacts/ht0fhw0z_Screenshot%202025-12-28%20at%2010.03.06%E2%80%AFPM.png', alt: 'Kothu Rotti Special' },
    { url: 'https://customer-assets.emergentagent.com/job_80ab25e3-c50b-48e9-b61c-5ff9eb1da9ab/artifacts/a5xd0hzq_Screenshot%202025-12-28%20at%2010.06.44%E2%80%AFPM.png', alt: 'Fresh Mango Lassi' },
    { url: 'https://customer-assets.emergentagent.com/job_80ab25e3-c50b-48e9-b61c-5ff9eb1da9ab/artifacts/ni7qpb0b_Screenshot%202025-12-28%20at%2010.57.52%E2%80%AFPM.png', alt: 'Mutton Curry' },
    { url: 'https://customer-assets.emergentagent.com/job_80ab25e3-c50b-48e9-b61c-5ff9eb1da9ab/artifacts/he0t3hda_Screenshot%202025-12-28%20at%2011.01.59%E2%80%AFPM.png', alt: 'Chicken Biryani' },
    { url: 'https://customer-assets.emergentagent.com/job_80ab25e3-c50b-48e9-b61c-5ff9eb1da9ab/artifacts/w7oi5jar_IMG_0358.JPG', alt: 'Traditional Sri Lankan Cuisine' }
  ];

  // Your 30 new uploaded files
  const localImages = [
    { url: "/000c8a0d-71df-49bc-b910-fdb9494331d6.JPG", alt: "New Dish 1" },
    { url: "/70f983a3-6764-4f0f-bf17-2f5a8c938afe.JPG", alt: "New Dish 2" },
    { url: "/80dfcae9-4dd8-48ff-8d2a-d11eb433133e.JPG", alt: "New Dish 3" },
    { url: "/9f35f018-3eb6-4edf-9f13-e85b0906d40c.JPG", alt: "New Dish 4" },
    { url: "/0063bbed-4cfd-45b7-9f90-9c753c358d79.JPG", alt: "Kothu Dish 1" },
    { url: "/14aa434a-dbbc-4ac5-b930-142e66244c5b.JPG", alt: "Kothu Dish 2" },
    { url: "/1b39a024-6507-4f42-bdde-f80f0a881b82.JPG", alt: "Kothu Dish 3" },
    { url: "/1d7045bb-0204-4669-bcbd-edda64bfdb40.JPG", alt: "Kothu Dish 4" },
    { url: "/1f285e08-7dcc-48d6-9e77-bc8b4e10fc72.JPG", alt: "Kothu Dish 5" },
    { url: "/3004fa45-e311-49f8-9713-4438ce28a068.JPG", alt: "Kothu Dish 6" },
    { url: "/590c446e-0cb9-490b-8ad9-0faebb591f58.JPG", alt: "Kothu Dish 7" },
    { url: "/5ad33bdb-8754-42fb-89fb-cd14efb00c37.JPG", alt: "Kothu Dish 8" },
    { url: "/6fe0bce1-7f0e-4fc4-971b-85fccc2cb497.JPG", alt: "Kothu Dish 9" },
    { url: "/7d5a7ffc-64b4-4fd0-ab8c-a626acbf13d1.JPG", alt: "Kothu Dish 10" },
    { url: "/8f11e9e7-4807-4583-892c-ee7cb1e13e8a.JPG", alt: "Kothu Dish 11" },
    { url: "/99412f0d-80d8-4150-bbf2-c09c102b496e.JPG", alt: "Kothu Dish 12" },
    { url: "/9b3ccfab-5e73-4c28-ba39-0f1690239776.JPG", alt: "Kothu Dish 13" },
    { url: "/a0ee03a6-a529-4b14-b424-7bf59207e82c.MP4", alt: "Kitchen Video 1", isVideo: true },
    { url: "/1151d475-159c-407e-8a9c-b8d2bca1db5c.MP4", alt: "Kitchen Video 2", isVideo: true },
    { url: "/352ad45a-2d36-4721-b1f7-f659a92b2872.MP4", alt: "Kitchen Video 3", isVideo: true },
    { url: "/678b2ba0-4d84-469e-b034-e762384d11a6.MP4", alt: "Kitchen Video 4", isVideo: true },
    { url: "/6c049674-32db-4c57-b1ac-570a45fdfad4.MP4", alt: "Kitchen Video 5", isVideo: true },
    { url: "/b011389d-e189-40b9-9039-61489d7b4bf5.MP4", alt: "Snack Prep Video", isVideo: true },
    { url: "/IMG_2376.jpeg", alt: "Restaurant Interior 1" },
    { url: "/IMG_2378.jpeg", alt: "Restaurant Interior 2" },
    { url: "/IMG_2379.jpeg", alt: "Food Special 1" },
    { url: "/IMG_2380.jpeg", alt: "Food Special 2" },
  ];

  // Combine old and new images into one final list
  const allImages = [...cdnImages, ...localImages];

  return (
    <section id="gallery" className="gallery-section">
      <div className="gallery-container">
        <div className="gallery-header animate-fade-in-up">
          <h2 className="section-title">Our Restaurant</h2>
          <div className="title-divider"></div>
          <p className="section-subtitle">Experience luxury dining and authentic flavors</p>
        </div>

        <div className="gallery-grid">
          {allImages.map((image, index) => (
            <div key={index} className="gallery-item image-hover">
              <div className="image-wrapper">
                {image.isVideo ? (
                  <video src={image.url} className="gallery-image" autoPlay loop muted playsInline />
                ) : (
                  <img src={image.url} alt={image.alt} className="gallery-image" />
                )}
                <div className="image-overlay">
                  <div className="overlay-content">
                    <p className="overlay-text">Kothu Rotti</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
